module.exports = __webpack_public_path__ + "img/schlosserei-halle.ef8ac112.webp";